// @flow
import { LARGE_VIEWPORT, MEDIUM_VIEWPORT, SMALL_VIEWPORT } from '@alphaott/app-config'
import { rgba } from 'polished'

import { colorPalette } from '../colorPalettes'
import type { ColorType } from '../colorPalettes'

export const itplayColors: ColorType = { ...colorPalette, primary: '#F60030', secondary: '#F60030' }

export const lightTheme = {
  colors: itplayColors,
  background: {
    primary: '#fafafa',
    secondary: '#fafafa',
    highlight: itplayColors.light,
    select: '#fafafa',
    footerTop: '#eee',
  },
  text: {
    primary: itplayColors.dark,
    secondary: itplayColors.grayText,
    disabled: itplayColors.dark,
    link: itplayColors.dark,
    hint: itplayColors.dark,
    highlight: itplayColors.primary,
    gray: itplayColors.grayText,
    seeAll: 'rgba(52, 73, 94, 0.8)',
    primaryContrast: '#ffffff',
  },
  border: {
    primary: '#dddddd',
    gray: '#ddd',
  },
  filter: {
    primary: '#43484d',
    secondary: '#43484d',
    disabled: itplayColors.grayLabel,
    highlight: '#fff',
  },
  tabs: {
    bg: '#fafafa',
    containerBg: itplayColors.dark,
    color: itplayColors.dark,
    border: itplayColors.primary,
    scrollbarThumb: itplayColors.primary,
    programTitle: itplayColors.white,
  },
  programGuide: {
    programBox: {
      background: {
        main: 'rgba(221, 221, 221, 0.8)',
        hover: itplayColors.dark,
        selected: itplayColors.dark,
        progress: rgba(itplayColors.primary, 0.3),
        past: rgba(itplayColors.primary, 0.3),
        pastSelected: itplayColors.dark,
        pastHover: itplayColors.dark,
        empty: 'rgba(221, 221, 221, 0.3)',
        emptyProgress: rgba(itplayColors.primary, 0.1),
      },
      text: {
        empty: itplayColors.grayLabel,
      },
    },
    programGuidePictureOverlay: {
      horizontal:
        // eslint-disable-next-line max-len
        `linear-gradient(90deg, #fafafa 0%,${rgba('#fafafa', 0.97)} 13.03%,${rgba('#fafafa', 0.69)} 43.24%,${rgba(
          '#fafafa',
          0,
        )} 100%);`,
      vertical: `linear-gradient(0,#fafafa 0%,${rgba('#fafafa', 0.73)} 34.97%,${rgba('#fafafa', 0)} 100%);`,
    },
  },
  card: {
    title: itplayColors.dark,
    subTitle: itplayColors.grayText,
    bg: itplayColors.dark,
    number: itplayColors.grayBorder,
    boxShadow: 'rgba(221, 221, 221, 0.8)',
    loaderBackgroundImage: 'linear-gradient(to right, #f6f7f8 0%, #edeef1 20%, #f6f7f8 40%, #f6f7f8 100%)',
  },
  dimension: {
    signLogoSize: 160,
  },
  size: 'default',
  breakpoints: [`${SMALL_VIEWPORT}px`, `${MEDIUM_VIEWPORT}px`, `${LARGE_VIEWPORT}px`],
  signIn: {
    clipPath: false,
  },
}
